import { render, staticRenderFns } from "./MyCertificates.vue?vue&type=template&id=a940f6b6&lang=pug&"
import script from "./MyCertificates.vue?vue&type=script&lang=js&"
export * from "./MyCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports